import React from "react";

function MiscDownloadOnAppStore(props) {
  return (
    <div className="container me-5" style={{ marginTop: "5rem" }}>
      <div className="row justify-content-center align-items-center text-center">
        <div className="col-md-3">
          <img
            loading="lazy"
            alt="download_on_mobile"
            src="./images/appstore_download_image.png"
            style={{
              width: "400px",
              height: "auto",
              maxHeight: "400px",
              maxWidth: "400px",
            }}
          ></img>
        </div>
        <div className="d-flex col-md-3 justify-content-center align-items-center text-center">
          {/* Open appstore url */}
          <a href={props.id} target="_blank" rel="noreferrer">
            <img
              loading="lazy"
              className="my-auto"
              alt="download_on_mobile"
              src="./images/download_on_appstore.png"
              style={{
                width: "200px",
                height: "auto",
                maxHeight: "200px",
                maxWidth: "200px",
              }}
            ></img>
          </a>
        </div>
      </div>
    </div>
  );
}

export default MiscDownloadOnAppStore;
